import React from 'react';

import withSizes from 'react-sizes';

import {
  RollUpClickableTitle,
  WrapBannerImageWithHref,
} from '../../../../shared';
import { BannerDescription } from './BannerDescription/BannerDescription.jsx';

const mapSizesToProps = ({ width }) => ({
  winW: width
})

class BenefitsPurchaseTickets extends React.Component {
  bannerImgSrc() {
    return this.props.winW >= 1024
      ? '/img/2024/08/BenefitsPurchaseTickets/dt.jpg'
      : '/img/2024/08/BenefitsPurchaseTickets/mob.jpg'
  }

  render() {
    return (
      <div className='mp__sertificat'>
        <div className='wd'>
          <div className='sertificat'>
            <WrapBannerImageWithHref href={this.promoLink} src={this.bannerImgSrc()} />
            <RollUpClickableTitle title='ДІЮЧІ ПІЛЬГИ НА ПРИДБАННЯ КВИТКІВ ДЛЯ ПЕРЕГЛЯДУ ФІЛЬМІВ В КІНОТЕАТРІ «ЖОВТЕНЬ»' />
            <BannerDescription />           
          </div>
        </div>
      </div>
    )
  }
}

export default withSizes(mapSizesToProps)(BenefitsPurchaseTickets)



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/BenefitsPurchaseTickets/impl/BenefitsPurchaseTickets.jsx